/* tslint:disable */
/* eslint-disable */
/**
 * Ship to ship api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ConfigurationResponseSchema } from './ConfigurationResponseSchema';
import {
    ConfigurationResponseSchemaFromJSON,
    ConfigurationResponseSchemaFromJSONTyped,
    ConfigurationResponseSchemaToJSON,
} from './ConfigurationResponseSchema';

/**
 * 
 * @export
 * @interface PageConfigurationResponseSchema
 */
export interface PageConfigurationResponseSchema {
    /**
     * 
     * @type {Array<ConfigurationResponseSchema>}
     * @memberof PageConfigurationResponseSchema
     */
    items: Array<ConfigurationResponseSchema>;
    /**
     * 
     * @type {number}
     * @memberof PageConfigurationResponseSchema
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof PageConfigurationResponseSchema
     */
    page: number;
    /**
     * 
     * @type {number}
     * @memberof PageConfigurationResponseSchema
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof PageConfigurationResponseSchema
     */
    pages: number;
}

/**
 * Check if a given object implements the PageConfigurationResponseSchema interface.
 */
export function instanceOfPageConfigurationResponseSchema(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "items" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "page" in value;
    isInstance = isInstance && "size" in value;
    isInstance = isInstance && "pages" in value;

    return isInstance;
}

export function PageConfigurationResponseSchemaFromJSON(json: any): PageConfigurationResponseSchema {
    return PageConfigurationResponseSchemaFromJSONTyped(json, false);
}

export function PageConfigurationResponseSchemaFromJSONTyped(json: any, ignoreDiscriminator: boolean): PageConfigurationResponseSchema {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(ConfigurationResponseSchemaFromJSON)),
        'total': json['total'],
        'page': json['page'],
        'size': json['size'],
        'pages': json['pages'],
    };
}

export function PageConfigurationResponseSchemaToJSON(value?: PageConfigurationResponseSchema | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'items': ((value.items as Array<any>).map(ConfigurationResponseSchemaToJSON)),
        'total': value.total,
        'page': value.page,
        'size': value.size,
        'pages': value.pages,
    };
}

